export function loadingFullActive(loadingFull) {
  return {
    type: "LOADINGFULL",
    loadingFull,
  };
}
